<div class="signup_section">
  <div class="signup-left-section">
    <div class="header-website">
      <div class="close-image">
        <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/938590c1762168095149new_simpo_logo.svg" />
      </div>
    </div>
    <div class="login_body">
      <div class="section_title">Welcome back!</div>
      <div class="section_subtitle">Login to simpo.ai account</div>
      <div class="fields">
        <div class="field">
          <div class="label">Email Address or Mobile Number</div>
          <mat-form-field appearance="outline" class="taking_input custom-black-outline">
            <input matInput placeholder="Enter Email Address or Mobile Number"
              [(ngModel)]="businessDetails.contact.email" />
          </mat-form-field>
        </div>
        <div class="field">
          <div class="label">Password</div>
          <form [formGroup]="signin">
            <mat-form-field class="taking_input custom-black-outline" appearance="outline">
              <input matInput placeholder="Enter Password" [type]="signinHide ? 'password' : 'text'"
                formControlName="password" minlength="8" [(ngModel)]="businessDetails.pwd" (keyup.enter)="login()" />
              <mat-icon matSuffix (click)="signinHide = !signinHide" class="eye-icon">{{signinHide ? 'visibility_off' :
                'visibility'}}</mat-icon>
            </mat-form-field>
          </form>
          <div class="remember_forget">
            <div class="remeber">
            </div>
            <div class="forgot_password" (click)="forgotPassword()">Forgot password</div>
          </div>
        </div>
      </div>
      <div class="continue_btn">
        <button (click)="login()">
          <span *ngIf="!loader">Login</span>
          <span class="spinner" *ngIf="loader">
            <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="signin_right_section">
    <img src="./../../../../assets/images/common/login_image.svg" alt="signup_image">
  </div>
</div>